export function isVerum() {
  return window && window.location.hostname === "auth.verumpogoda.ru";
}

export function isReactNativeView() {
   return typeof window !== "undefined" && window.isReactNativeWebView === true;
}

export function isiOs() {
  return typeof navigator !== "undefined" && /iPad|iPhone|iPod|Macintosh/.test(navigator.userAgent);
}
